module.exports = __webpack_public_path__ + "img/front neck drop.ced50def.png";